import { useRef, useState } from 'react'
import { getMembersForDepartment } from '../../services/util'

export function CreateDepartment({ createDepartment, allMembers }) {
    const name = useRef()
    const [members, setMembers] = useState({})
    const type = useRef()
    const membersToAdd = useRef(getMembersForDepartment([], allMembers))

    const handleToggle = (id) => {
        let newMembers = { ...members }
        if (newMembers[id]) delete newMembers[id]
        else newMembers[id] = true
        setMembers(newMembers)
    }

    const onCreateDepartment = async (ev) => {
        ev?.preventDefault()
        createDepartment(name.current.value, type.current.value, members)

    }

    return <form className='send-invite' onSubmit={onCreateDepartment}>
        <h3>שם מחלקה</h3>
        <input
            style={{ marginBottom: '20px',textAlign:'right' }}
            type='text'
            ref={name}
            placeholder='שם מחלקה'
            required
        />

        <h3>סוג מחלקה</h3>
        <select ref={type}>
            <option value='producer'>מפיקים</option>
        </select>

        <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>חברים במחלקה</h3>
        <div className="roles-checkboxes" style={{ marginBottom: '20px' }}>
            {membersToAdd.current.map((member) => <label className='opt-wrapper' key={member._id}>
                <input
                    type="checkbox"
                    maxLength={16}
                    checked={members[member._id]}
                    onChange={() => handleToggle(member._id)}
                />
                <p>{member.name}</p>
            </label>)}

        </div>

        <button className='arise'>צור מחלקה</button>
    </form>
}
